import type { Plugin } from 'chart.js';

export const alternatingBackgroundPlugin: Plugin<'bar'> = {
    id: 'alternatingBackground',
    beforeDatasetsDraw(chart) {
        const { ctx, chartArea, scales } = chart;
        const xScale = scales['x'];

        if (!xScale || !chartArea) return;

        const tickCount = xScale.ticks.length;
        const barWidth = (xScale.right - xScale.left) / tickCount;

        ctx.save();

        Array.from({ length: tickCount }, (_, i) => i).forEach((i) => {
            if (i % 2 === 0) {
                const xPos = xScale.getPixelForTick(i);

                ctx.fillStyle = 'rgba(211, 32, 41, 0.04)';
                ctx.fillRect(
                    xPos - barWidth / 2,
                    chartArea.top,
                    barWidth,
                    chartArea.bottom - chartArea.top,
                );
            } else {
                const xPos = xScale.getPixelForTick(i);

                ctx.fillStyle = 'rgba(0, 196, 26, 0.04)';
                ctx.fillRect(
                    xPos - barWidth / 2,
                    chartArea.top,
                    barWidth,
                    chartArea.bottom - chartArea.top,
                );
            }
        });

        ctx.restore();
    },
};
